import React from 'react';
import PageTemplate from '@/components/ui/PageTemplate';
import { HOME_CONTEXT } from '@/constants/context';
import useObserver from '@/hooks/page/useObserver';
import BannerModal from '@/components/BannerModal';
import PlatformNavBar from '@/components/navigationBar/PlatformNavBar';
import { VIDEO_URLS } from '@/constants/videos';

const Home = () => {
  useObserver(
    'content-Home',
    'content-Home-desktop',
    'video-background',
    'video-landing-page'
  );

  return (
    <PageTemplate id='Home'>
      <BannerModal />
      <video
        id='video-landing-page'
        className='md:hidden absolute inset-0 h-full w-full object-cover pointer-events-none'
        muted
        autoPlay
        loop
        controls={false}
        disablePictureInPicture
        playsInline
        onContextMenu={e => e.preventDefault()}
      >
        <source src={VIDEO_URLS.LANDING_PAGE} />
      </video>
      <section
        id='content-Home'
        className='relative md:hidden w-full max-w-[360px] mx-auto overflow-hidden rounded-none'
      >
        <div className='relative z-10 flex flex-col gap-14 py-12 text-center text-white mt-16'>
          <header className='flex w-full justify-center'>
            <img src='/logo/Slogan.png' alt='logo' className='h-auto w-[90%]' />
          </header>
          <main className='flex flex-col text-sm font-medium px-4'>
            <p>We are developing a real-time</p>
            <p>decision-making platform for the</p>
            <p>
              safety and efficiency of space assets.
            </p>
            <p>The safety, optimization, and intelligence problems for satellite constellations are our main decision-making problems.</p>
          </main>
          <div className='flex w-full justify-center px-4'>
            <PlatformNavBar />
          </div>
        </div>
      </section>

      {/* Desktop Layout: Overlay (Original Design) */}
      {/* Video Background (Desktop Only) */}
      <section
        id='video-background'
        className='absolute hidden md:block top-0 left-0 w-full h-full overflow-hidden'
      >
        <video
          className='w-full h-full object-cover pointer-events-none'
          muted
          autoPlay
          loop
          playsInline
          controls={false}
          disablePictureInPicture
          onContextMenu={e => e.preventDefault()}
        >
          <source src={VIDEO_URLS.LANDING_PAGE} />
        </video>
      </section>
      <div
        id='content-Home-desktop'
        className='hidden md:flex relative h-fit gap-4 z-[1] flex-col justify-center items-center box-border w-full py-36 xl:max-w-[1060px] md:max-w-[688px] mx-auto'
      >
        <div className='w-full h-full flex flex-col justify-center items-center gap-20'>
          <header className='w-full box-border m-0 p-0 pt-12 flex items-center justify-center'>
            <img
              src='/logo/Slogan.png'
              alt='logo'
              className='xl:w-[80%] md:w-[100%] h-auto'
            />
          </header>
          <main className='xl:flex hidden w-full flex-col justify-center text-center'>
            <p className='text-2xl font-medium text-white'>
              We are developing a real-time decision-making platform
            </p>
            <p className='text-2xl font-medium text-white'>
              for the safety and efficiency of space assets.
            </p>
            <p className='text-2xl font-medium text-white'>
              The safety, optimization, and intelligence problems for
            </p>
            <p className='text-2xl font-medium text-white'>
              satellite constellations are our main decision-making problems.
            </p>
          </main>
          <main className='flex xl:hidden w-full flex-col justify-center text-center'>
            <p className='text-2xl font-medium text-white'>
              We are developing a real-time decision-making
            </p>
            <p className='text-2xl font-medium text-white'>
              platform for the safety and efficiency of space assets.
            </p>
            <p className='text-2xl font-medium text-white'>
              The safety, optimization, and intelligence problems<br /> for
              satellite constellations are <br />our main decision-making problems.
            </p>
          </main>
          <div className='w-full h-full flex flex-col justify-center items-center gap-4'>
            <PlatformNavBar />
          </div>
        </div>
      </div>
    </PageTemplate>
  );
};

export default React.memo(Home);
